import styles from "./BackArrow.module.scss";

export default function BackArrow() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={styles.back_arrow} viewBox="0 0 489.3 489.3">
            <path d="m450.29 214.11-333.62-2 148.81-151c12.78-12.97 12.78-33.77 0-46.73s-33.28-12.97-46.05 0L14.99 221.84c-12.78 12.97-12.78 33.77 0 46.73l204.44 207.46c6.39 6.48 14.64 9.72 23.16 9.72s16.77-3.24 23.16-9.72c12.78-12.97 12.78-33.77 0-46.73l-148.81-151 333.62 2c18.1 0 32.74-14.86 32.74-33.23-.27-18.37-14.91-32.96-33.01-32.96z" />
        </svg>
    );
}
